import api from "../../api";

class PedidosNutri {
  index() {
    return api.get("nutri/pedidos");
  }

  store(data) {
    return api.post("nutri/pedidos", data);
  }

  listOrders(month, year, services) {
    return api.get(`nutri/pedidos/list/${month}/${year}/${services}`);
  }
}

export default new PedidosNutri();
